<template>
  <div class="list_card" @click="toDetail">
    <div class="zhuan_li_hao">{{ obj.projectCode }}</div>
    <div class="flex-between-left">
      <div style="width: 100%">
        <div class="biao_ti line" :style="`width:${obj.image ? '70%' : '100%'}`">
          {{ obj.title }}
        </div>
        <div class="jie_shao line" :style="`width:${obj.image ? '70%' : '100%'}`">
          {{ obj.projectBrief }}
        </div>
      </div>
      <div class="img flex-center" v-if="obj.image && obj.image.length > 2">
        <el-image fit="cover" style="width: 100%; height: 50px" :src="obj.image | getImgsOne">
        </el-image>
      </div>
    </div>
    <div class="biao_qian flex-left flex-wrap" v-if="obj.types && obj.types.length > 0">
      <div class="flex-center" :class="inde == 0 ? 'checked' : ''" v-for="(ite, inde) in obj.labels" :key="inde">
        {{ ite }}
      </div>
    </div>
    <div class="flex-between flex-wrap">
      <div class="ming_cheng flex-left-center">
        <span></span>
        <div class="line">{{ obj.userName }}</div>
      </div>
      <div class="jia_ge flex-end-center" v-if="obj.price || obj.price == 0">
        <!-- <span class="flex-center">折扣价</span> -->
        ¥{{ obj.price }}万元
      </div>
      <div class="jia_ge flex-end-center" v-else>面议</div>
    </div>
  </div>
</template>

<script>
import { getImgsOne } from "../api/util";
export default {
  //过滤器
  filters: {
    getImgsOne(val) {
      return getImgsOne(val);
    },
  },
  methods: {
    // 跳转详情
    toDetail() {
      let data = `id=${this.obj.id}`;

      if (this.tj.length > 0) data += `&tj=${this.tj}`;

      this.$router.push(`/details?${data}`);
    },
  },
  created() {
    // console.warn(this.obj, '你好');
  },

  // 子组件接收
  props: {
    obj: {
      type: Object,
      default() {
        return {};
      },
    },
    tj: {
      type: String,
      default() {
        return "";
      },
    },
  },
};
</script>

<style lang="scss">
.list_card:hover {
  transition: box-shadow 0.3s, border-color 0.3s;
  visibility: visible;
  box-shadow: 0px 0px 20px #ccc;
}

.list_card {
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e6eb;
  width: 31%;
  padding: 16px 20px;
  margin-top: 24px;
  cursor: pointer;

  .ming_cheng {
    font-size: 12px;
    font-weight: 400;
    color: #4e5969;
    width: 65%;

    &>div {
      width: 80%;
    }

    span {
      display: block;
      width: 24px;
      height: 24px;
      background: #f2f3f5;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .jia_ge {
    font-size: 18px;
    font-weight: 500;
    color: #eb5757;

    span {
      display: inline-block;
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #eb5757;
      background: #ffece8;
      padding: 0 6px;
      margin-right: 8px;
    }
  }

  .biao_qian {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    padding: 16px 0;
    margin-bottom: 18px;
    border-bottom: 1px solid #e5e6eb;

    &>div {
      height: 20px;
      background: #f2f3f5;
      border-radius: 2px 2px 2px 2px;
      padding: 0 6px;
      margin-right: 8px;
    }

    .checked {
      color: #165dff;
      background: #e8f3ff;
    }
  }

  .zhuan_li_hao {
    font-size: 12px;
    font-weight: 400;
    color: #a9aeb8;
    margin-bottom: 16px;
  }

  .biao_ti {
    font-size: 18px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
  }

  .jie_shao {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    line-height: 20px;
  }

  .img {
    width: 30%;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    margin-left: 10px;

    img {
      width: 100%;
      max-height: 100%;
    }
  }
}
</style>
